module.exports = __webpack_public_path__ + "static/media/Main-exterior.63f75d23.jpg";